import { IBrokerEnvironment } from '@inshuwa-client/models';
import { devBaseUrl } from '../configs/constants';

export const environment: IBrokerEnvironment = {
  insurerId: null,
  partnerId: null,
  primaryColor: '#520B4D',
  secondaryColor: '#d8205a',
  name: 'Inshuwa',
  logoUrl: '../assets/inshuwa_logo.png',
  baseURL: devBaseUrl,
  debug: true,
  favIcon: '../assets/favicon.ico',
  portalName: 'Brokers Portal',
  broker: true,
};
